export class SearchParameters {
    appId: string;
    apiKey: string;
    trackingConsent: boolean;
    indices: { [key: string]: string };
    index: string = '';
    queryId: string = '';
    query: string = '';
    isSaleSuggestionsActive: boolean = false;
    isQuerySuggestionsActive: boolean = false;
    isRecentlyViewedActive: boolean = false;
}